import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ICON } from '@core/util/icon';
import { SnackbarService } from '@services/ui/snackbar.service';
import { MatterUploadedFilesDispatch } from '@state/matter/uploaded-files/matter-uploaded-files.dispatch';

export interface DeleteDocumentData {
	id: string;
	title: string;
}

@Component({
	selector: 'app-delete-document-modal',
	templateUrl: './delete-document-modal.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class DeleteDocumentModalComponent {
	public id: string;
	public title: string;
	public ICON = ICON;

	constructor(
		public dialogRef: MatDialogRef<DeleteDocumentModalComponent>,
		@Inject(MAT_DIALOG_DATA) public data: DeleteDocumentData,
		private matterUploadedFilesDispatch: MatterUploadedFilesDispatch,
		private snackbarService: SnackbarService,
	) {
		this.id = data.id;
		this.title = data.title;
	}

	removeDocument(): void {
		this.matterUploadedFilesDispatch.Delete(this.id);
		this.snackbarService.openSnackBar({
			text: `${this.title} deleted`,
			type: 'info',
			icon: ICON.DELETE,
		});
		this.close();
	}

	close(): void {
		this.dialogRef.close();
	}
}
